(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3AdvertisementBanner', {
            templateUrl: 'app/shared/advertisement-banner/advertisement-banner.component.html',
            controller: AdvertisementBannerComponent
        });

    AdvertisementBannerComponent.$inject = ['$window', '$state', 'culture', 'user', '$transitions'];
    function AdvertisementBannerComponent(window, $state, culture, user, $transitions) {
        var ctrl = this;
        Object.defineProperty(ctrl, 'isAdminPage', { get: getIsAdminPage });

        ctrl.culture = culture.get().substring(0, 2);
        ctrl.user = user;
        ctrl.width = window.innerWidth || document.documentElement.clientWidth;
        console.log(ctrl.width);

        var isDefined = false;
        console.log("0");
        $transitions.onSuccess({},
            function (event) {
                if (!isDefined & !ctrl.isAdminPage) {
                    
                    if (event && event.router && event.router.urlRouter && event.router.urlRouter.location) {
                        var location = event.router.urlRouter.location;
                        if (user) {
                    
                            var membershipLevel = ctrl.user.membershipLevel && ctrl.user.membershipLevel == "Gold" ? "FullMembership" : "TrialMemberWithGametracker";

                            window.googletag = window.googletag || { cmd: [] };

                            // New Ad 07/01/24
                            //window.googletag.cmd.push(function () {
                            //    window.googletag.defineSlot('/61175202/Golf_Canada_Network_Leaderboard_BigBox', [[320, 50], [320, 100], [300, 250], [728, 90]], 'div-gpt-ad-1715780993550-0').addService(window.googletag.pubads());
                            //});

                            
                            if (ctrl.width < 728) {
                                window.googletag.cmd.push(function () {
                                    window.googletag.defineSlot('/61175202/Golf_Canada_Network_Leaderboard_BigBox', [[320, 50], [320, 100], [300, 250]], 'div-gpt-ad-1715780993550-0').addService(window.googletag.pubads());
                                });
                            } else {
                                window.googletag.cmd.push(function () {
                                    window.googletag.defineSlot('/61175202/Golf_Canada_Network_Leaderboard_BigBox', [[728, 90]], 'div-gpt-ad-1715780993550-0').addService(window.googletag.pubads());
                                });
                            }
                            

                    

                            // Set Targeting
                            window.googletag.cmd.push(function () {
                                console.log("4");
                                window.googletag.pubads().enableSingleRequest();
                                window.googletag.pubads().setTargeting('domain', ['scg.golfcanada.ca']);
                                window.googletag.pubads().setTargeting('url', [location]);
                                window.googletag.pubads().setTargeting('lang', [ctrl.culture + '-CA']); // Either 'en-CA' or 'fr-CA'
                                window.googletag.pubads().setTargeting('member_card_id', [ctrl.user.golfCanadaCardId]); // Or set an empty array of []
                                window.googletag.pubads().setTargeting('membership_level', [membershipLevel]); // Either 'FullMembership', 'TrialMemberWithGametracker', or set an empty array of []
                                window.googletag.pubads().setTargeting('gender', []); // Either 'M', 'F', or set an empty array of []
                                window.googletag.enableServices();
                            });

                            // Wait to Display
                            window.googletag.cmd.push(function () {
                                window.googletag.display('div-gpt-ad-1715780993550-0');
                            });

                            isDefined = true;
                                        
                        }
                    }
                }
            });
        

        function getIsAdminPage() {
            var data = $state.$current.data;
            return data && data.requireAdmin;
        }
    }
})();
